import { useEffect, useRef } from 'react';
import { tg } from './telegram';

/**
 * Кнопка «назад» телеграма.
 *
 * Своей стрелки в углу у нас нет намеренно: в телеграме за возврат
 * отвечает клиент, и две кнопки «назад» на одном экране — это вопрос
 * «а эти две одинаковые?», которого быть не должно.
 *
 * `canGoBack` пуст на первом экране: кнопка там показывала бы выход
 * из приложения, а выход — это свайп вниз, и он уже есть.
 */
export function useBackButton(canGoBack: boolean, onBack: () => void): void {
  const handler = useRef(onBack);
  handler.current = onBack;

  useEffect(() => {
    const app = tg();
    if (!app) return;

    const fire = (): void => handler.current();
    app.BackButton.onClick(fire);

    return () => {
      app.BackButton.offClick(fire);
      app.BackButton.hide();
    };
  }, []);

  useEffect(() => {
    const app = tg();
    if (!app) return;

    if (canGoBack) app.BackButton.show();
    else app.BackButton.hide();
  }, [canGoBack]);
}
